import React from "react";
import MuiChip from "@material-ui/core/Chip";
import withStyles from "components/with-styles";
import styles from "./styles/chip.css.js";

const Chip = props => <MuiChip {...props} />;

export default withStyles(styles)(Chip);
